import * as React from 'react';

// Delete me
export const Thing = (props: any) => {
  return <div>{props.text}</div>;
};
